import { render, staticRenderFns } from "./ModificarCategorias.vue?vue&type=template&id=ea754cfe&scoped=true&"
import script from "./ModificarCategorias.vue?vue&type=script&lang=js&"
export * from "./ModificarCategorias.vue?vue&type=script&lang=js&"
import style0 from "./ModificarCategorias.vue?vue&type=style&index=0&id=ea754cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea754cfe",
  null
  
)

export default component.exports